'use client';

import { useEffect } from 'react';

const HISTORY_NAVIGATION_GRACE_MS = 1000;

let lastHistoryNavigationAt = Number.NEGATIVE_INFINITY;

if (globalThis.window !== undefined) {
  globalThis.addEventListener('popstate', () => {
    lastHistoryNavigationAt = performance.now();
  });
}

let preservedScroll: { pathname: string; top: number } | null = null;

export const preserveScrollOnEnter = (pathname: string) => {
  preservedScroll = { pathname, top: globalThis.scrollY };
};

export const ScrollToTopOnEnter = () => {
  useEffect(() => {
    const preserved = preservedScroll;
    preservedScroll = null;
    if (preserved?.pathname === globalThis.location.pathname) {
      globalThis.scrollTo({ top: preserved.top, behavior: 'instant' });
      return;
    }
    if (performance.now() - lastHistoryNavigationAt < HISTORY_NAVIGATION_GRACE_MS) return;
    globalThis.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return null;
};
